import { reactify } from '@zeiss/zui-react';
export const ZuiIconRmsClippingPlaneXZ = reactify('zui-icon-rms-clipping-plane-x-z');
